<nav class="navbar navbar-expand-lg">
  <div class="container-fluid">
    <button
      class="sidebar-toggle"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Abrir menú de navegación"
    >
      <i class="material-icons">menu</i>
    </button>
    <div class="navbar-wrapper">
      <app-page-header></app-page-header>
    </div>
    <div class="navbar-actions">
      @if (currentUser) {
        <button
          class="user-profile-chip"
          type="button"
          [matMenuTriggerFor]="userMenu"
          aria-label="Abrir menú de usuario"
        >
          <div class="user-avatar" [class.has-photo]="!!currentUser.photo">
            @if (currentUser.photo) {
              <img
                [src]="currentUser.photo"
                [alt]="currentUser.name + ' ' + currentUser.surname"
              />
            } @else {
              <span>{{ userInitials }}</span>
            }
          </div>
          <div class="user-info">
            <strong>{{ currentUser.name }} {{ currentUser.surname }}</strong>
          </div>
          <span class="user-menu-caret">
            <i class="material-icons user-menu-icon">expand_more</i>
          </span>
        </button>
      }
    </div>
  </div>
</nav>

<mat-menu #userMenu="matMenu" xPosition="before" class="user-dropdown-menu">
  <button mat-menu-item type="button" (click)="navigateToProfile()">
    <span class="menu-item-icon"
      ><i class="material-icons">manage_accounts</i></span
    >
    <span class="menu-item-label">Configurar perfil</span>
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="logout()"
    class="menu-item-danger"
  >
    <span class="menu-item-icon"><i class="material-icons">logout</i></span>
    <span class="menu-item-label">Cerrar sesión</span>
  </button>
</mat-menu>
